module.exports = __webpack_public_path__ + "img/pijltje-klein-down.404af76d0028f2f975bcd3c021dae463.svg";